<template>
  <div class="mb-52">
    <AdvancedMetricsFilterForm
      :result-references="previousLabels"
      :activity-filter="true"
      :initial-filter="filter"
      :object-type="'company'"
      @update="handleUpdateFilter" />
  </div>
</template>

<script>
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"

import { transformMetricFilterToServerFilter } from "@/services/data.transformers"

export default {
  components: { AdvancedMetricsFilterForm },
  props: { selectedNode: null, previousLabels: null },
  emits: ["updateValues"],

  data() {
    return {
      filter: "",
      prevent_watch: false
    }
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        if (!this.prevent_watch) {
          this.handleUpdateValues()
        }
      }
    }
  },
  created() {
    this.init()
  },

  methods: {
    handleUpdateFilter(filter) {
      const filter_cleaned = []
      filter.forEach((item) => {
        if (item.data_type == "String") {
          if (Array.isArray(item.value)) {
            item.value = String(item.value)
          }
          // let value = item.value.replace(/[']+/g, "")
          filter_cleaned.push({
            ...item,
            value: item.value == null ? "" : item.value.trim()
          })
        } else {
          if (
            item.value == null ||
            item.value == undefined ||
            item.value == "" ||
            item.value == "null" ||
            item.value == "undefined" ||
            item.value == "None"
          ) {
            item.value = null
          } else if (
            (item.data_type == "Date" || item.data_type == "DateTime") &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DD")
          } else if (
            item.data_type == "DateTime" &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DDTHH:mm:ss")
          }
          filter_cleaned.push({ ...item, value: item.value })
        }
      })
      let parsed_filter = transformMetricFilterToServerFilter([...filter_cleaned])

      if (!this.prevent_watch) {
        this.filter = parsed_filter.filter
      }

      this.handleUpdateValues()
    },

    handleUpdateValues() {
      const data = {
        ...this.selectedNode.data.values,
        valid: true,
        filter: this.filter
      }

      this.$emit("updateValues", data)
    },
    init() {
      this.prevent_watch = true
      this.filter = this.$utils.clone(this.selectedNode.data.values.filter)

      setTimeout(() => {
        this.prevent_watch = false
      }, 600)
    }
  }
}
</script>
